import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const ContactFormComponent = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    // Determine language from pathname
    const isEnglish = pathname.startsWith('/en');
    const targetPath = isEnglish
      ? '/en/about-us/contact-and-visit'
      : '/de/ueber-uns/kontakt-und-besuch';

    // Redirect to the appropriate language-specific contact page
    history.replace(targetPath);
  }, [history, pathname]);

  return null;
};

export default ContactFormComponent;
